import axios from 'axios';
import { setRefreshToken, setSession } from 'contexts/JWTContext';
import jwt_decode from 'jwt-decode';
import { getToken } from './Helpers';
import { refreshTokenURL } from './serverUrls';

const axiosServices = axios.create({
    baseURL: process.env.REACT_APP_SERVICE_URL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
});

// TODO
//  need to implement refresh token. currently server don't have any refresh token api
axiosServices.interceptors.request.use();

// interceptor for http
axiosServices.interceptors.request.use((request) => {
    const token = getToken('token');

    if (token) {
        request.headers!.Authorization = `Bearer ${token}`;
    }
    return request;
});

// refresh token
axiosServices.interceptors.request.use(
    async (config) => {
        const token = getToken('token');
        try {
            if (token) {
                const jwt: any = jwt_decode(token);
                if (jwt.exp < Math.floor(new Date().getTime() / 1000)) {
                    const res = await axios.post(`${process.env.REACT_APP_SERVICE_URL}/${refreshTokenURL}`, {
                        refreshToken: getToken('refreshToken')
                    });
                    if (res.data) {
                        setSession(res.data.token);
                        setRefreshToken(res.data.refresh_token.token);
                    }
                }
            }
        } catch (e) {
            localStorage.removeItem('token');
            sessionStorage.removeItem('token');
        }
        return config;
    },
    (err) => {
        console.log('error in getting ', err);
    }
);

// interceptor for http response
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 403) {
            localStorage.removeItem('token');
            sessionStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosServices;
